export default __webpack_public_path__ + "static/media/packagesFormsImg.1a279554.jpg";